export default {
  USER: "USER",
  ADMIN: "ADMIN",
};
